const main = {
	//加密
	encode:function(str){
		var staticStr = '';
		var alArr = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
		var agArr = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
		var nArr = ['0','1','2','3','4','5','6','7','8','9'];
		
		for(var i = 0; i < 26; i++){
			var str1 = alArr[i] + agArr[25 - i];
			if(i <= 9){
				str1 += nArr[i];
			}
			
			staticStr += str1;
		}
		
		var encodeStr = '';
		for(var i = 0; i < str.length; i++){
			var num0 = staticStr.indexOf(str[i]);
			if(num0 == -1){
				//未找到
				var code = str[i];
			}else{
				//已匹配
				var code = staticStr[(num0 - 0 +3)%62];
			}
			
			var num1 = parseInt(Math.random()*62,10);
			var num2 = parseInt(Math.random()*62,10);
			encodeStr += staticStr[num1] + code + staticStr[num2];
		}
		
		return encodeStr;
	},
	//解密
	decode:function(str){
		var staticStr = '';
		var alArr = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
		var agArr = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
		var nArr = ['0','1','2','3','4','5','6','7','8','9'];
		
		for(var i = 0; i < 26; i++){
			var str1 = alArr[i] + agArr[25 - i];
			if(i <= 9){
				str1 += nArr[i];
			}
			
			staticStr += str1;
		}
		
		var decodeStr = '';
		for(var i = 1; i < str.length;){
			var num0 = staticStr.indexOf(str[i]);
			if(num0 == -1){
				var code = str[i];
			}else{
				var code = staticStr[(num0 - 0 + 59)%62];
			}
			
			decodeStr += code;
			i = i + 3;
		}
		
		return decodeStr;
	}
}

export default main;



// WEBPACK FOOTER //
// ./src/assets/js/main.js